module.exports = __webpack_public_path__ + "static/6-bc4eaddf95307b3ba389ffec0ac22a4f.jpg";